import React from 'react';
import PropTypes from 'prop-types';
import RecommendedMeals from '../components/RecommendedMeals';
import StartRecipeButton from '../components/StartRecipeButton';
import ListDetailsDrinks from '../components/ListDetailsDrinks';
import BackButton from '../components/BackButton';

function DrinksDetails(props) {
  const { match: { params: { id } } } = props;
  const { location: { pathname } } = props;
  return (
    <div className="d-detailsPage">
      <BackButton />
      <ListDetailsDrinks id={ id } pathname={ pathname } />
      <RecommendedMeals />
      <StartRecipeButton type="drinks" id={ id } />
    </div>
  );
}

DrinksDetails.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.string }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string }).isRequired,
};

export default DrinksDetails;
